module.exports = __webpack_public_path__ + "990a65bc1c00dcb1fc5948891e21a4c2.png";